// extracted by mini-css-extract-plugin
export default {"container":"text_container__fWVI1","input":"text_input__oHvdD","searchIcon":"text_searchIcon__HrMoj"};